module.exports = __webpack_public_path__ + "static/img/en-new.1fa08a70.png";